import { initFlightSearchPanels } from '../lib/flight-search-panel.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFlightSearchPanels);
} else {
  initFlightSearchPanels();
}
